export default __webpack_public_path__ + "img/filter_SP.a81bd2c1f16e132b9ca27aa34762abc8.jpg";